import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  overflow: hidden;

  &:first-of-type {
    border-radius: 12px 12px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 12px 12px;
  }
`

export const category: Interpolation<Theme> = (theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  font-size: 12px;
  line-height: 1.25;
  background-color: ${theme.backgrounds.backgroundTwo};
  color: ${theme.typographyColors.typographyThree};
  cursor: pointer;
  user-select: none;
`

export const togglePlatformsButton: Interpolation<Theme> = css`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  margin: -10px;
  border: none;
  background-color: transparent;
  color: currentColor;
  cursor: pointer;
`

export const chevron: Interpolation<Theme> = (theme) => css`
  width: 15px;
  height: 15px;
  margin-left: 4px;
  transform: rotate(180deg);
  transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
`

export const rotatedChevron: Interpolation<Theme> = css`
  transform: rotate(0);
`

export const list: Interpolation<Theme> = (theme) => css`
  list-style-type: none;
  margin: 0;
  padding: 0;
  background-color: ${theme.backgrounds.backgroundThree};
`

export const li: Interpolation<Theme> = (theme) => css`
  &:not(:last-child) {
    border-bottom: 1px solid ${theme.backgrounds.backgroundTwo};
  }
  user-select: none;
`

export const link: Interpolation<Theme> = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  text-decoration: none;
`

export const disabledLink: Interpolation<Theme> = css`
  pointer-events: none;
`

export const platformInfo: Interpolation<Theme> = css`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const title: Interpolation<Theme> = (theme) => css`
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.28;
  color: ${theme.typographyColors.typographyTwo};
`

export const description: Interpolation<Theme> = (theme) => css`
  font-size: 12px;
  line-height: 1.5;
  color: ${theme.typographyColors.typographyThree};
`

export const checkmarkWrapper: Interpolation<Theme> = (theme) => css`
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  margin-left: 5px;
  background-color: ${theme.colors.green};
  border-radius: 50%;
`

export const checkmark: Interpolation<Theme> = (theme) => css`
  width: 9px;
  color: ${theme.colors.white};
`
